import type { McPlaybookCheck } from "../../lib/mc";

/** A playbook's checks, read-only, numbered in run order. */
export default function PlaybookChecksList({
  checks,
  "aria-label": ariaLabel,
}: {
  checks: Pick<McPlaybookCheck, "text" | "notes">[];
  "aria-label"?: string;
}) {
  return (
    <ol
      aria-label={ariaLabel}
      className="m-0 flex list-none flex-col gap-3 p-0"
    >
      {checks.map((check, index) => (
        <li key={index} className="flex gap-2 text-sm">
          <span
            className="w-6 shrink-0 text-right tabular-nums text-gray-500"
            aria-hidden="true"
          >
            {index + 1}.
          </span>
          <div className="flex min-w-0 flex-col gap-0.5">
            <span className="break-words text-gray-900">{check.text}</span>
            {check.notes && (
              <span className="whitespace-pre-wrap break-words text-[13px] text-gray-500">
                {check.notes}
              </span>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
